import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';

type InitialState = {
  loading: boolean;
};

const initialState: InitialState = {
  loading: false,
};

export type MediaUploadState = Readonly<typeof initialState>;

const mediaUploadSlice = createSlice({
  name: 'mediaUpload',
  initialState,
  reducers: {
    setMediaUploadLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

const { actions, reducer } = mediaUploadSlice;
export const { setMediaUploadLoading } = actions;
export default reducer;
